<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="container-style needs-validation" [formGroup]="formDocumentSupport" novalidate>
        <div class="ps-2 pe-1">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-modal #copyDocumentModal [header]="'Copiar'" [children]="componentCopyDocument"
                [inputs$]="inputsForCopyDocument$" [output$]="output$" [width]="'40vw'" hidden></app-custom-modal>
              <app-custom-button title="Copiar" [severity]="'contrast'" [icon]="'pi pi-copy'"
                (onClick)="clickDocument()">
              </app-custom-button>
              <app-custom-button title="Imprimir" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()">
              </app-custom-button>

              <!-- Adjuntar archivos -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileDocumentSupport [header]="'Adjuntar archivos'"
                [children]="componentAttachFiles" [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$"
                [output$]="outputForAttachFiles$" hidden></app-custom-modal>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteDocumentSupport()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewDocumentSupport()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="documentSupportContract.userNameCreate"
                [createDate]="documentSupportContract.createDate"
                [userNameUpdate]="documentSupportContract.userNameUpdate"
                [updateDate]="documentSupportContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 col-12">
              <div class="row">
                <div class="col-lg-3 col-md-2 col-sm-3">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-3">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-3 col-8">
                  <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo'"
                    [list]="filteredListBussinessDocumentsTypes" [required]="true" [recovery]="true"
                    (onChangeSelect)="getBussinessDocumentsType($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-4">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateDocument" [labelText]="'Fecha'" [required]="true"
                    (onChangeDate)="validateDate()"></app-custom-datepicker>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-9 col-12">
                  <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProvider"
                    [required]="true" (onChangeSelect)="getProvider($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-5 col-md-6 col-sm-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [maxLength]="250"></app-custom-textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="row d-flex justify-content-end">
                <div class="col-lg-4 col-md-3 col-sm-3 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-2 d-flex align-items-end mt-2">
                  <div class="d-flex gap-1">
                    <app-custom-button [title]="titleState" [icon]="iconState"
                      (onClick)="changeDocumentSupportState()"></app-custom-button>
                  </div>
                </div>
                <div class="col-lg-4 col-md-2 col-sm-2 col-4">
                  <app-custom-input-text [disabled]="true" [labelText]="'Nro.Doc.Original'"
                    [value]="documentSupportOrigin.toString()">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-3 col-4 mt-3 align-content-center">
                  <app-custom-checkbox formControlName="swCopied" [labelText]="'Doc. Copiado'"></app-custom-checkbox>
                </div>
                <div class="col d-flex justify-content-star align-items-end mt-3">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <app-document-support-detail [disabledDetail]="disabledDetail" [updateListDetail]="updateListDetail"
            [documentSupportModel]="documentSupportContract" [quantityDetails]="quantityDetails"
            (emitQuantityDetails)="quantityDetails = $event; " [disabledActions]="disabledActions"
            (updateDocumentSupport)="getUpdateDocumentSupport($event)">
          </app-document-support-detail>
        </div>
      </div>
      <form [formGroup]="formDocumentSupportFooter" class="needs-validation container-style mt-2">
        <div class="row">
          <div class="col-12 col-lg-7 mb-2">
            <div class="d-flex flex-wrap gap-4 mb-2">
              <div class="d-flex align-items-center gap-2">
                <label class="fw-bold">Interfaz:</label>
                <p class="mb-0">{{ electronicInvoiceInterfaceCode }}</p>
              </div>
              <div class="d-flex align-items-center gap-2">
                <label class="fw-bold">Interfaz Contable: </label>
                <p class="mb-0">{{ accountingInterfaceCode }}</p>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center gap-2">
                <label class="fw-bold">CUDS: </label>
                <p class="mb-0 text-break ">{{ (documentSupportContract.cuds ?? '').toString() }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5">
            <div class="row d-flex justify-content-end">
              <div class="col-md-3 col-sm4 col-6 mb-2">
                <app-custom-input-decimal formControlName="noteCredit"
                  [labelText]="'Nota Crédito'"></app-custom-input-decimal>
              </div>
              <div class="col-md-3 col-sm4 col-6 mb-2">
                <app-custom-input-decimal formControlName="residue" [labelText]="'Saldo'"></app-custom-input-decimal>
              </div>
              <div class="col-md-3 col-sm-4 col-6 mb-2">
                <app-custom-input-decimal formControlName="totalValue" [labelText]="'Total'"></app-custom-input-decimal>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!-- Imprimir Factura -->
<div id="container-print-document-support">
  <app-print-document-support id="print-document-support" [companyId]="companyId" [formatModel]="formatModel"
    [documentSupportModel]="documentSupportPrintModel" [editFormat]="false" [printDocument]="true" [focusText]="false"
    (finishLoadingPrintDocumentSupport)="finishLoading($event)">
  </app-print-document-support>
</div>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>